import React from "react";
import PropTypes from "prop-types";
import Str from "shared/components/Str";
import _str from "shared/util/_str";
import LockSvg from "shared/components/svgs/lock.svg";
import Terms from "./Terms";
import { LANDING_SCREEN_VARIANTS } from "./constants";

import "./LandingScreen.scss";

const CONTENT = {
	[LANDING_SCREEN_VARIANTS.PROTECT]: {
		title: _str("Protect your account"),
		subtitle: _str("Add your phone number to secure your account from hackers."),
		actionLabel: _str("Add phone number"),
		helpSection: (
			<a
				className="sms-actions-button sms-actions-link"
				href="https://help.okcupid.com/article/202-sms-verification"
				target="_blank"
				rel="noopener noreferrer"
			>
				<Str>Learn more</Str>
			</a>
		),
		headerIcon: null,
	},
	[LANDING_SCREEN_VARIANTS.VERIFY]: {
		title: _str("Verification required"),
		subtitle: _str("For community safety, you must secure your account in order to send messages."),
		actionLabel: _str("Verify Account"),
		helpSection: <Terms />,
		headerIcon: (
			<div className="sms-header-icon">
				<LockSvg />
			</div>
		),
	},
};

const LandingScreen = ({ handleEnterPhoneClick, variant }) => (
	<div className={`sms-migration-modal-landingscreen sms-migration-modal-landingscreen-${variant}`}>
		<div className="sms-header">
			{CONTENT[variant].headerIcon}
			<span className="sms-header-title">
				{CONTENT[variant].title}
			</span>
			<span className="sms-header-subtitle">
				{CONTENT[variant].subtitle}
			</span>
		</div>
		<div className="sms-fields-container">
			<div>
				<div className="oknf oknf--gray sms-form">
					<div className="sms-actions">
						<button
							className="sms-actions-button"
							onClick={(e) => {
								e.preventDefault();
								handleEnterPhoneClick();
							}}
						>
							{CONTENT[variant].actionLabel}
						</button>
						{CONTENT[variant].helpSection}
					</div>
				</div>
			</div>
		</div>
	</div>
);

LandingScreen.propTypes = {
	handleEnterPhoneClick: PropTypes.func.isRequired,
	variant: PropTypes.oneOf(Object.values(LANDING_SCREEN_VARIANTS)).isRequired,
};

export default LandingScreen;



// WEBPACK FOOTER //
// ./src/shared/components/SmsMigrationModal/LandingScreen.jsx